import DESTINATION_ENUM from 'web/destinations/DESTINATION_ENUM';

export const destinationKeysMappings = {
  [DESTINATION_ENUM.REDSHIFT]: {
    user: 'User',
    host: 'Host',
    port: 'Port',
    database: 'Database',
    password: 'Password',
    ssl: 'SSL',
    pgschema: 'Schema',
  },
  [DESTINATION_ENUM.SNOWFLAKE]: {
    account: 'Account Locator + Region',
    authentication_method: 'Authentication Method',
    database: 'Database',
    role: 'User Role',
    snowflake_schema: 'Schema',
    storage_integration_name: 'Storage Integration Name',
    username: 'Username',
    warehouse: 'Warehouse',
    password: 'Password',
    private_key: 'Private Key',
    passphrase: 'Passphrase',
  },
  [DESTINATION_ENUM.S3]: {
    assume_role: 'Assume Role',
    bucket_name: 'Bucket Name',
    namespace: 'Prefix',
  },
  [DESTINATION_ENUM.BIGQUERY]: {
    project_id: 'Project ID',
    client_email: 'Client Email',
    private_key: 'Private Key',
  },
};
